export const PORTFOLIO_DATA = [
  {
    id: 1,
    category: ["mobile", "frontend"],
    title: "Last Battle VIP Loyalty Program",
    image: "http://fakeimg.pl/365x365/",
    description: "A loyalty program designed to engage users with an exclusive experience. Built with React Native and Node.js.",
    tags: ["Web Development", "UI/UX", "QA", "Project Management"],
  },
  {
    id: 2,
    category: ["frontend"],
    title: "15% Daily Cashback",
    image: "http://fakeimg.pl/365x365/",
    description: "A seamless cashback system with an intuitive frontend built using Next.js and Tailwind CSS.",
    tags: ["Web Development", "UI/UX", "QA"],
  },
  {
    id: 3,
    category: ["mobile", "frontend"],
    title: "Weekly Ortak Festival",
    image: "http://fakeimg.pl/365x365/",
    description: "A dynamic event-based platform powered by React and Flutter for a smooth multi-device experience.",
    tags: ["Web Development", "UI/UX"],
  },
  {
    id: 4,
    category: ["frontend", "designing"],
    title: "100% Welcome Offer on Sportsbook",
    image: "http://fakeimg.pl/365x365/",
    description: "A visually engaging landing page designed with Adobe XD and developed in React.",
    tags: ["Web Development", "UI/UX", "QA", "Project Management"],
  },
  {
    id: 5,
    category: ["mobile", "frontend"],
    title: "100% Casino Welcome Bonus of Up to €250",
    image: "http://fakeimg.pl/365x365/",
    description: "A fast and secure casino app featuring Redux state management and a sleek UI built with Figma.",
    tags: ["Web Development", "UI/UX", "QA"],
  },
  {
    id: 6,
    category: ["frontend"],
    title: "10% Daily Cashback on Sports",
    image: "http://fakeimg.pl/365x365/",
    description: "An interactive and optimized sports cashback system powered by Next.js and MongoDB.",
    tags: ["Web Development", "UI/UX"],
  },
  {
    id: 7,
    category: ["mobile"],
    title: "20 + 1 Spins",
    image: "http://fakeimg.pl/365x365/",
    description: "A mobile gaming feature built with React Native and Firebase, ensuring real-time updates.",
    tags: ["Web Development", "UI/UX", "QA", "Project Management"],
  },
  {
    id: 8,
    category: ["frontend"],
    title: "2 Goals Ahead - Early Payout Offer",
    image: "http://fakeimg.pl/365x365/",
    description: "A user-friendly early payout system with a responsive UI, leveraging Tailwind and Redux.",
    tags: ["Web Development", "UI/UX"],
  },
  {
    id: 9,
    category: ["mobile", "frontend"],
    title: "7% Weekly Cashback Live Casino & TV Games",
    image: "http://fakeimg.pl/365x365/",
    description: "An engaging live casino experience designed with Flutter and Prisma for smooth database management.",
    tags: ["Web Development", "UI/UX", "QA"],
  },
  {
    id: 10,
    category: ["frontend", "designing"],
    title: "Get Up to 100% Extra Cash for Multiple Bets",
    image: "http://fakeimg.pl/365x365/",
    description: "A bet management system with an enhanced UI built using Figma and Next.js for a seamless experience.",
    tags: ["Web Development", "UI/UX"],
  },
  {
    id: 11,
    category: ["frontend", "others"],
    title: "Telegram Bot",
    image: "http://fakeimg.pl/365x365/",
    description: "An automated Telegram bot developed with Node.js and integrated with PostgreSQL for smart interactions.",
    tags: ["Web Development", "QA"],
  },
];
